export default "__VITE_ASSET__B5HtJz1J__"